
import {
  mapState,
} from 'vuex'
import {Toast} from "vant";
import _ from "lodash";

export default {
  props: {
    text: {
      type: Object,
    },
  },
  data(){
    return {
      backup: '',
      content: '',
      placeholder:  this.$t('append_field.enterMediaURL'),
    }
  },
  mounted() {
    if(this.text.txList[0]){
      this.content=this.text.txList[0].taContent
    }
    this.backup = _.cloneDeep(this.$store.state.componentsList[this.controlIndex]);
  },
  methods: {
    replace() {
      this.$emit('edit')
    },
    submit() {
      if (this.content === '') {
        Toast(this.$t('append_field.enterText'))
        return
      }else {
        Toast(this.$t('append_field.add_success'))
      }
      this.$emit('setText', this.content)
    },
    fullscreen() {
      this.$emit('fullscreen')
    },
    close() {
      this.$store.state.componentsList[this.controlIndex].txList = this.backup.txList
      this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.backup)
      this.$emit('close')
    },
  },
  computed: {
    ...mapState({
      controlIndex: state => state.controlIndex,
      componentsList: state => state.componentsList,
    })
  },
}
